import { render, staticRenderFns } from "./PurchaseReceivingIndex.vue?vue&type=template&id=7040fba4&scoped=true&"
import script from "./PurchaseReceivingIndex.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040fba4",
  null
  
)

export default component.exports